import styled from 'styled-components';
import { getBodyStyle, getColor, Theme } from 'styles/theme';

export const RadioWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  align-items: center;
  margin-left: 24px;
  position: relative;
  margin: 0;
  
  .label {
    overflow: inherit;
    position: relative;
    display: flex;
    align-items: center;
  }

  .required {
    color: ${getColor('textAccentSecondary')};
  }

  &.disabled {
    .check-mark {
      border: 2px solid ${getColor('iconSecondary')};
    }
    label {
      cursor: default;
    }
  }

  &.error {
    .check-mark{
      border: 2px solid ${getColor('semanticsError')};
    }

    label {
      color: ${getColor('textAccentSecondary')};
    }
  }
`;

export const RadioInput = styled.input<{ theme: Theme }>`
  visibility: hidden;
  height: 0;
  width: 0;

  &:checked ~ .check-mark {
    &::after {
      content: "";
      width: 10px;
      height: 10px;
      border-radius: 100%;
      top: 7px;
      left: 5px;
      background-color: ${getColor('surfaceBlack')};
    }
  }
`;

export const Label = styled.label<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' }, 'regular')}
  line-height: 24px;
  letter-spacing: 0.5px;
  cursor: pointer;
  color: ${getColor('textPrimary')};
`;

export const Checkmark = styled.span<{ theme: Theme }>`
  height: 20px;
  width: 20px;
  background-color: ${getColor('surfaceWhite')};
  border: 2px solid ${getColor('borderBlack')};
  border-radius: 100%;
  margin-right: 8px;  

  &::after {
    position: absolute;
    content: "";
    display: inline-block;
  }
`;
